export let allFoldersInArchive = "RvS5N";
export let allFoldersString = "h12Gcb";
export let currentMailboxString = "UD1sO";
export let allMailboxesString = "CbKh1d";
export default {allFoldersInArchive,allFoldersString,currentMailboxString,allMailboxesString};